import { NavLink, Outlet } from 'react-router-dom'

const tabs = [
  { to: '/member-ledger/unit-ledger', label: 'Unit ledger' },
  { to: '/member-ledger/vesting', label: 'Vesting' },
] as const

export default function MemberLedgerLayout() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="bg-white border-b border-gray-200 shrink-0">
        <div className="px-4 lg:px-6 py-3">
          <h1 className="hidden text-xl font-semibold text-gray-900 lg:block">Member Ledger</h1>
          <p className="mt-0.5 text-sm text-gray-500">
            Unit ownership and vesting schedules
          </p>
        </div>

        <div className="border-t border-gray-200 px-4 lg:px-6 py-4">
          <div className="overflow-x-auto">
            <div
              className="inline-flex gap-2 bg-gray-200 p-1 rounded-lg min-w-max"
              role="tablist"
              aria-label="Member Ledger sections"
            >
              {tabs.map((tab) => (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  role="tab"
                  className={({ isActive }) =>
                    `px-4 py-1.5 rounded-md text-sm font-medium transition-all whitespace-nowrap ${
                      isActive
                        ? 'bg-white text-brand-700 shadow-sm'
                        : 'text-gray-600 hover:text-gray-900'
                    }`
                  }
                >
                  {tab.label}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-3 py-3 sm:px-6 sm:py-4 lg:px-8">
        <Outlet />
      </div>
    </div>
  )
}
